<template>
  <div>
    <custom-text :msg="customText" :customValue="studentData" class="mt-3"></custom-text>
    <v-container fluid grid-list-lg px-1>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4 xl2 v-for="(property, headerKey) in studentProfileSection" :active="active" :key="headerKey">
          <v-card tile style="height: 100%;">
            <v-card-title>
              <div class="headline truncate">
                <span v-if="$i18n.keyExists(getStudentHeaderKey(headerKey))">{{$t(getStudentHeaderKey(headerKey))}}</span>
                <span v-else>{{headerKey}}</span>
              </div>
            </v-card-title>
            <v-card-text v-for="(valueKey, titleKey) in property" :key="titleKey" class="pt-0">
              <div class="caption truncate">
                <span v-if="$i18n.keyExists(getStudentTitleKey(titleKey))">{{$t(getStudentTitleKey(titleKey))}}</span>
                <span v-else>{{titleKey}}</span>
              </div>
              <div class="prevent-overflow title">
                <span v-if="$i18n.keyExists(getStudentValueKey(valueKey))">{{$t(getStudentValueKey(valueKey))}}</span>
                <span v-else>{{valueKey}}</span>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import CustomText from '../../help/CustomText'
  import { GET_STUDENT_PROFILE } from '../../../store/action-types'
  import { mapActions, mapState } from 'vuex'
  import Roles from '../../../mixins/Roles'

  export default {
    name: 'StudentProfile',
    props: ['studentProfile', 'active', 'studentId'],
    mixins: [Roles],
    methods: {
      ...mapActions({
        getStudentProfile: GET_STUDENT_PROFILE
      }),
      loadData () {
        this.getStudentProfile(this.studentId)
      },
      getStudentHeaderKey (headerKey) {
        return `student.profile.header.${headerKey}`
      },
      getStudentTitleKey (titleKey) {
        return `student.profile.title.${titleKey}`
      },
      getStudentValueKey (valueKey) {
        return `student.profile.value.${valueKey}`
      }
    },
    computed: {
      studentProfileSection () {
        return Object.keys(this.studentProfile)
          .reduce((previous, key) => {
            return Object.assign(previous, this.studentProfile[key])
          }, {})
      },
      ...mapState({
        studentData: state => state.student
      }),
      customText () {
        let role = this.isAdmin ? 'admin' : (this.isStaff ? 'staff' : 'student')
        return 'custom-text.' + role + '.profile'
      }
    },
    components: {
      CustomText
    },
    watch: {
      active (nowActive) {
        if (nowActive) {
          this.loadData()
        }
      }
    },
    mounted () {
      if (this.active) {
        this.loadData()
      }
    }
  }
</script>

<style scoped>
.headline {
  font-weight: 500;
  font-size: 24px;
}
.title {
  font-weight: 400;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/student/profile/StudentProfile.vue